export default __webpack_public_path__ + "static/mastodon-icon-spacing-5412c2b6ff22c14c3e363fb0e1393b6a.png";